export function parseConfig() {
  const script = document.currentScript ||
    [...document.querySelectorAll('script[data-app-id]')].pop();
  if (!script) throw new Error('[MC] Missing script tag with data-app-id');

  const d    = script.dataset;
  const str  = (v, def = '')    => (v !== undefined && v !== '') ? v : def;
  const num  = (v, def = 0)     => (v !== undefined && v !== '') ? parseInt(v, 10) : def;
  const bool = (v, def = false) => v === undefined ? def : (v === 'true' || v === '1');
  const json = (v, def = [])    => { try { return JSON.parse(v || JSON.stringify(def)); } catch { return def; } };
  const hex  = (v, def = '')    => (v && /^#([0-9a-f]{3,8})$/i.test(v.trim())) ? v.trim() : def;

  return Object.freeze({
    appId:   str(d.appId),
    apiUrl:  str(d.apiUrl).replace(/\/$/, ''),

    primaryColor:          hex(d.primaryColor,          '#5046e4'),
    primaryGradientEnd:    hex(d.primaryGradientEnd,    ''),
    primaryGradientAngle:  num(d.primaryGradientAngle,  135),
    userBubbleColor:       hex(d.userBubbleColor,       ''),
    userBubbleTextColor:   hex(d.userBubbleTextColor,   '#ffffff'),
    botBubbleColor:        hex(d.botBubbleColor,        ''),
    botBubbleTextColor:    hex(d.botBubbleTextColor,    ''),
    bgColor:               hex(d.bgColor,               ''),
    bgMessagesColor:       hex(d.bgMessagesColor,       ''),
    headerTextColor:       hex(d.headerTextColor,       '#ffffff'),
    timestampColor:        hex(d.timestampColor,        ''),
    chipBorderColor:       hex(d.chipBorderColor,       ''),
    chipTextColor:         hex(d.chipTextColor,         ''),
    chipBgColor:           hex(d.chipBgColor,           ''),
    inputBgColor:          hex(d.inputBgColor,          ''),
    inputTextColor:        hex(d.inputTextColor,        ''),
    inputPlaceholderColor: hex(d.inputPlaceholderColor, ''),
    footerTextColor:       hex(d.footerTextColor,       ''),
    footerLinkColor:       hex(d.footerLinkColor,       ''),
    sendButtonColor:       hex(d.sendButtonColor,       ''),
    sendButtonIconColor:   hex(d.sendButtonIconColor,   '#ffffff'),
    statusDotColor:        hex(d.statusDotColor,        '#34d399'),
    typingDotColor:        hex(d.typingDotColor,        ''),
    launcherColor:         hex(d.launcherColor,         ''),
    launcherIconColor:     hex(d.launcherIconColor,     '#ffffff'),
    badgeColor:            hex(d.badgeColor,            '#f43f5e'),
    shadowColor:           str(d.shadowColor,           ''),

    variant:                       str(d.variant,                    'popup'),
    floatpanelDesktopWidth:        str(d.floatpanelDesktopWidth,     '50vw'),
    floatpanelMobileWidth:         str(d.floatpanelMobileWidth,      '92vw'),
    floatpanelInputBg:             hex(d.floatpanelInputBg,          ''),
    floatpanelInputTextColor:      hex(d.floatpanelInputTextColor,   ''),
    floatpanelInputBorderColor:    hex(d.floatpanelInputBorderColor, ''),
    floatpanelGradientColor1:      hex(d.floatpanelGradientColor1,   ''),
    floatpanelGradientColor2:      hex(d.floatpanelGradientColor2,   ''),
    floatpanelGradientColor3:      hex(d.floatpanelGradientColor3,   ''),
    floatpanelGradientColor4:      hex(d.floatpanelGradientColor4,   ''),
    floatpanelPanelBg:             hex(d.floatpanelPanelBg,          ''),
    floatpanelBackdropFrom:        num(d.floatpanelBackdropFrom,      50),
    floatpanelIconColor:           hex(d.floatpanelIconColor,        ''),
    floatpanelPlaceholder:         str(d.floatpanelPlaceholder,      'Ask me anything…'),

    theme:               str(d.theme,             'light'),
    botName:             str(d.botName,           'Magecomp Assistant'),
    botAvatar:           str(d.botAvatar,         ''),
    botInitials:         str(d.botInitials,       'MC'),
    botStatusText:       str(d.botStatusText,     'Online · Typically replies instantly'),
    welcomeMessage:      str(d.welcomeMessage,    'Hi there! 👋 How can I help you today?'),
    welcomeMessage2:     str(d.welcomeMessage2,   ''),
    errorMessage:        str(d.errorMessage,      'Something went wrong. Please try again.'),
    placeholder:         str(d.placeholder,       'Ask me anything...'),
    typingText:          str(d.typingText,        'Assistant is typing'),
    locale:              str(d.locale,            'en'),
    userId:              str(d.userId,            ''),
    userName:            str(d.userName,          ''),
    userEmail:           str(d.userEmail,         ''),
    userBusinessName:    str(d.userBusinessName,  ''),
    userAvatar:          str(d.userAvatar,        ''),
    userInitials:        str(d.userInitials,      ''),

    position:             str(d.position,          'bottom-right'),
    offsetX:              num(d.offsetX,            24),
    offsetY:              num(d.offsetY,            24),
    width:                num(d.width,              370),
    height:               num(d.height,             580),
    panelRadius:          num(d.panelRadius,        20),
    launcherSize:         num(d.launcherSize,       52),
    launcherRadius:       num(d.launcherRadius,     50),
    zIndex:               num(d.zIndex,             9999),
    mobileFullscreen:     bool(d.mobileFullscreen,  true),
    mobileBreakpoint:     num(d.mobileBreakpoint,   768),

    autoOpen:               bool(d.autoOpen,               false),
    openDelay:              num(d.openDelay,               0),
    minimized:              bool(d.minimized,              false),
    showTimestamps:         bool(d.showTimestamps,         true),
    timestampFormat:        str(d.timestampFormat,         'time'),
    showTypingIndicator:    bool(d.showTypingIndicator,    true),
    showAvatar:             bool(d.showAvatar,             true),
    showAvatarGrouped:      bool(d.showAvatarGrouped,      false),
    allowAttachments:       bool(d.allowAttachments,       false),
    stream:                 bool(d.stream,                 true),
    persistHistory:         bool(d.persistHistory,         true),
    maxHistory:             num(d.maxHistory,              50),
    soundEnabled:           bool(d.soundEnabled,           false),
    showBranding:           bool(d.showBranding,           true),
    showClearButton:        bool(d.showClearButton,        true),
    showHeaderSubtitle:     bool(d.showHeaderSubtitle,     true),
    showNotificationBadge:  bool(d.showNotificationBadge, true),
    inputMaxRows:           num(d.inputMaxRows,            4),
    typingSpeed:            num(d.typingSpeed,             18),
    inactivityReviewSeconds:num(d.inactivityReviewSeconds, 30),

    suggestedQuestions: json(d.suggestedQuestions, []),
    subScript:          str(d.subScript,           ''),
    metadata:           json(d.metadata,           {}),
  });
}
